<div [ng2-highcharts]="chartOptions"></div>
